import HighlightedCard from "./ui-blocks/elements/highlightedCard";

const CARDS = [
    {
        color: "purple",
        badgeText: "GLOBAL NEWS APP",
        headline: "Global News Media Coverage",
        description: "A news aggregation app built to surface real-time coverage from major outlets across the US, UK, Europe, and Asia. ",
        bulletPoints: ["Live article feeds", "40+ integrated sources", "Region and topic filters", "iOS and web support"],
        statNumber: "40+ media outlets",
        statDescription: "Over 40 global news sources integrated at launch.",
        footerText: "One feed for the whole world. No more jumping between a dozen news sites.",
        imageURL: "https://storage.googleapis.com/extern-academy.firebasestorage.app/images/misc/694585e1f89851c0d60b57c8_aiforschools_mobile-1.webp",
        imageALT: "Global News Media Coverage App",
    },
    {
        color: "yellow",
        badgeText: "PRODUCTIVITY APP",
        headline: "Cross-Platform Task List Application",
        description: "A task management app built for iOS with full feature parity across both platforms. The shipped product is a to-do manager with sync, recurring tasks, and offline support.",
        bulletPoints: ["iOS app", "Recurring tasks", "Offline support", "Cross-device sync"],
        statNumber: "iOS app",
        statDescription: "Cross platform iOS app to manage your daily TODOs.",
        footerText: "Manage every to-do, on any device, online or off.",
        imageURL: "https://storage.googleapis.com/extern-academy.firebasestorage.app/images/misc/tasks-app-ios-1.webp",
        imageALT: "Cross-platform Task list app",
    },
    {
        color: "blue",
        badgeText: "AI TOOL",
        headline: "AI Debate Moderator Coach",
        description: "An AI-powered debate coach that moderates practice rounds, tracks argument structure, and scores performance in real time. Available for students interested in debate and public speaking.",
        bulletPoints: ["Live round moderation", "Argument scoring", "Rebuttal analysis", "Performance history"],
        statNumber: "200+ rounds moderated",
        statDescription: "Over 200 practice debate rounds run in the first week after launch.",
        footerText: "This product is offered in the 48-Day cohort.",
        imageURL: "https://storage.googleapis.com/extern-academy.firebasestorage.app/images/misc/original-f992e7b0103c765f19a4b3d141b4b0ab.webp",
        imageALT: "AI Debate Moderator Coach",
    },
];

const STICKY_TOP = 80; // px from top when card is pinned

export default function HighlightedCardGroup() {
    return (
        <div className="py-16">
            {/* Header */}
            <div className="text-center mb-12 px-6">
                <p className="text-xs font-semibold tracking-widest uppercase text-blue-500 mb-2">
                    Student Work
                </p>
                <h2 className="text-4xl font-bold text-gray-900 mb-3">
                    Consumer Products from Externs
                </h2>
                <p className="text-gray-500 max-w-xl mx-auto">
                    A sample of products an extern can expect to build. All products built by externs are free; none are sold to consumers.
                </p>
            </div>

            {/* Sticky stack */}
            <div className="relative px-4 md:px-8" style={{ paddingBottom: "2px" }}>
                {CARDS.map((card, i) => (
                    <div
                        key={i}
                        style={{
                            position: "sticky",
                            top: STICKY_TOP + i * 10,
                            zIndex: i + 1,
                            marginBottom: i < CARDS.length - 1 ? "24px" : 0,
                        }}
                    >
                        <HighlightedCard {...card} />
                    </div>
                ))}

                {/* Scroll spacer so the last card can fully exit sticky */}
                <div style={{ height: "1px" }} />
            </div>
        </div>
    );
}
